import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { isModuleApiUrl } from './module-api';

/**
 * Attaches the mock bearer token to module backend calls, and to nothing else.
 *
 * Mock mode only: with real sign-in the application registers the library's
 * `saphirTokenInterceptor` instead, which owns the real token and its renewal.
 *
 * Must run *after* `apiUrlInterceptor`, so the URL is already resolved and the
 * check below can tell a module backend apart from other endpoints. A module
 * that calls a third-party URL gets no token — the credential goes only to the
 * backends of `environment.api.modules`.
 */
export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const token = inject(AuthService).accessToken();

  if (!token || !isModuleApiUrl(request.url)) {
    return next(request);
  }

  return next(request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
